import { Component, Signal, WritableSignal, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ExportRequest, closeDownloadsDropdown, loadExportDetails, openDownloadsDropdown, removeExport, updateExportCreationTime } from '../../../store/export-downloads/export-downloads.actions';
import { AppState } from '../../../app.reducer';
import { Store } from '@ngrx/store';
import { selectAllExports, selectExportsCount, selectReadyExports, selectShowDownloads } from '../../../store/export-downloads/export-downloads.reducer';
import { FontawesomeService } from '../../../services/fontawesome.service';
import { SpinnerComponent } from '@catch/general-ui';
import { DatePipe } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { JobsAdapter } from '../../../adapters/jobs.adapter';

@Component({
  selector: 'app-sidenav-downloads',
  template: `
  <div class="ct-card">
    <div class="header">
      <h5>{{ 'company-tool.topnav.downloads.title' | transloco }}</h5>
      <div class="actions">
        
      </div>
    </div>
    <div class="downloads-wrapper" [class.no-downloads]="allExports()?.length === 0">
      @if (allExports()?.length === 0) {
        <p class="text-center" @illustration>
          {{ 'company-tool.topnav.downloads.no-downloads' | transloco }}
        </p>
      }
      @for (exportItem of allExports() ?? []; track exportItem.exportId) {
        <div class="download-item">
          <div class="content">
            <b>{{ exportItem.jobTitle }}</b>
            <span>{{ exportItem.isPending ? ('company-tool.topnav.downloads.preparing' | transloco) : exportItem.filename }}</span>
            @if (!exportItem.isPending && exportItem.creationTime) {
              <span class="timestamp">{{ exportItem.creationTime | date: 'medium' }}</span>
            }
          </div>
          <div class="actions">
            @if (exportItem.isPending) {
              <div class="spinner-wrapper">
                <ct-lib-spinner></ct-lib-spinner>
              </div>
              <fa-icon
                class="remove"
                [icon]="fontawesomeService.light.times"
                [tooltip]="'company-tool.topnav.downloads.remove' | transloco"
                position="left"
                (click)="removeExport(exportItem)"
              ></fa-icon>
            } @else {
              <fa-icon
                [icon]="fontawesomeService.light.download"
                [tooltip]="'company-tool.topnav.downloads.download' | transloco"
                position="left"
                (click)="downloadExport(exportItem)"
              ></fa-icon>
              <fa-icon
                class="remove"
                [icon]="fontawesomeService.light.times"
                [tooltip]="'company-tool.topnav.downloads.remove' | transloco"
                position="left"
                (click)="removeExport(exportItem)"
              ></fa-icon>
            }
          </div>
        </div>
      }
    </div>
  </div>
  `,
  styleUrls: ['./sidenav-downloads.component.scss'],
  imports: [TranslocoPipe, SpinnerComponent, DatePipe, FontAwesomeModule]
})
export class SidenavDownloadsComponent {
  public readonly fontawesomeService = inject(FontawesomeService);
  private readonly store = inject(Store<AppState>);
  private readonly jobsAdapter = inject(JobsAdapter);
  
  public allExports = this.store.selectSignal(selectAllExports);
  public exportsCount = this.store.selectSignal(selectExportsCount);


  downloadExport(exportItem: ExportRequest) {
    this.jobsAdapter
      .getExportStatus(exportItem.jobId, exportItem.exportId)
      .subscribe({
        next: (status) => {
          if (status.downloadUrl) {
            window.open(status.downloadUrl, '_blank');
          }
          if (status.creationTime) {
            this.store.dispatch(
              updateExportCreationTime({
                exportId: exportItem.exportId,
                creationTime: status.creationTime,
              })
            );
          }
          this.store.dispatch(removeExport({ exportId: exportItem.exportId }));
          this.store.dispatch(closeDownloadsDropdown());
        },
      });
  }

  removeExport(exportItem: ExportRequest) {
    this.store.dispatch(removeExport({ exportId: exportItem.exportId }));
  }

  openDownloadsDropdown() {
    const count = this.store.selectSignal(selectExportsCount)();
    if (count > 0) {
      this.store.dispatch(openDownloadsDropdown());
      const exports = this.store.selectSignal(selectReadyExports)();
      const withoutCreationTime = exports.filter((e) => !e.creationTime);
      if (withoutCreationTime.length > 0) {
        this.store.dispatch(loadExportDetails({ exports: withoutCreationTime }));
      }
    }
  }

  closeDownloadsDropdown() {
    this.store.dispatch(closeDownloadsDropdown());
  }
}
